import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import DataImportJob from '@/model/DataImportJob';
import Page from '@/model/Page';
import { dataImportJobStore } from '@/store/DataImportJobStore';

export default class GeneratedDataImportServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getDataImportJobs(): Promise<DataImportJob[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getDataImportJobs', rpcParams, false).then((data: any) => {
            if (data && Array.isArray(data)) {
                const dataImportJobs: DataImportJob[] = data.map(dataImportJob => Object.assign(new DataImportJob(), dataImportJob))
                dataImportJobStore.replaceDataImportJobs(dataImportJobs)
                return dataImportJobs
            } else return Promise.reject()
        })
    }


    _createDataImportJob(newJob: DataImportJob): Promise<number> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('createDataImportJob', rpcParams, false).then((data: any) => {
            const model = Object.assign(new DataImportJob(), data)
            dataImportJobStore.addOrReplaceDataImportJob(model)
            return model.id
        })
    }

    _removeDataImportJob(id: number): Promise<void> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('removeDataImportJob', rpcParams, false).then(() => {
            dataImportJobStore.removeDataImportJob(id)
        })
    }

    _startDataImportJob(id: number): Promise<number> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('startDataImportJob', rpcParams, false).then((data: any) => {
            const model = Object.assign(new DataImportJob(), data)
            dataImportJobStore.removeDataImportJob(id)
            dataImportJobStore.addOrReplaceDataImportJob(model)
            return model.id
        })
    }

    _stopDataImportJob(id: number): Promise<number> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('stopDataImportJob', rpcParams, false).then((data: any) => {
            const model = Object.assign(new DataImportJob(), data)
            dataImportJobStore.removeDataImportJob(id)
            dataImportJobStore.addOrReplaceDataImportJob(model)
            return model.id
        })
    }

    _getUSBStorageDrives(): Promise<any[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getUSBStorageDrives', rpcParams, false) as Promise<any[]>
    }

    _getDataImportLog(id: number): Promise<string> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getDataImportLog', rpcParams, false) as Promise<string>
    }

    getDataImportJobs(refresh?: boolean | number): SWR<DataImportJob[], number[]> {
        //@ts-ignore
        const result: SWR<DataImportJob[], number[]> = reactive(new SWR<DataImportJob[], number[]>())
        const args: any[] = Array.prototype.slice.call(arguments, 0, 0).filter(arg => arg !== undefined)
        const callId: string = '_getDataImportJobs' + JSON.stringify(args)
        const cached: Call<number[]> | undefined = this.cache.get(callId)
        if (refresh === undefined && cached && cached.ended) {
            for (const [ id, call ] of this.cache) {
                if (id.startsWith('_getDataImportJobs[') && id !== callId && (!call.ended || call.ended > cached.ended)) {
                    refresh = 3000
                    break
                }
            }
        }
        if (cached && !cached.ended) {
            result.call = cached
            cached.promise?.then((data: number[]) => {
                const dataImportJobs: DataImportJob[] = []
                for (const id of data) {
                    const dataImportJob: DataImportJob | undefined = dataImportJobStore.state.dataImportJobs.get(id)
                    if (dataImportJob) {
                        dataImportJobs.push(dataImportJob)
                    }
                }
                result.data = dataImportJobs
            })
        } else if (refresh !== -1 && (!cached || refresh === true || (typeof refresh === 'number' && (cached.ended || 0) < (Date.now() - refresh)))) {
            const call = reactive(new Call<number[]>()) as Call<number[]>
            this.cache.set(callId, call)
            call.loading = !cached
            call.refreshing = !!cached
            //@ts-ignore since Array.filter does not provide nullsafe guard
            call.promise = this._getDataImportJobs().then((data: DataImportJob[]) => {
                //@ts-ignore since Array.filter does not provide nullsafe guard
                result.data = data
                //@ts-ignore since Array.filter does not provide nullsafe guard
                call.data = data.map(dataImportJob => dataImportJob.id || '')
                return call.data
            }).catch(e => {
                setTimeout(() => {
                  this.cache.delete(callId)
                }, 1000)
                return Promise.reject(e)
            }).finally(() => {
                call.ended = Date.now()
                call.loading = false
                call.refreshing = false
            })
            result.call = call
        }
        let dataImportJobs: DataImportJob[] = [...dataImportJobStore.state.dataImportJobs.values()]
        
        
        
        result.data = dataImportJobs
        return result
    }

    getDataImportJob(id: number): DataImportJob | undefined {
        return dataImportJobStore.state.dataImportJobs.get(id)
    }
}
